import { Router } from '@angular/router';
import { SharedService } from 'app/main/shared.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
var AdminGuard = /** @class */ (function () {
    function AdminGuard(router) {
        this.router = router;
    }
    AdminGuard.prototype.canActivate = function (route, state) {
        var roleData = SharedService.get(SharedService.user_group_id);
        if (SharedService.get(SharedService.LOGIN) == 'true' && roleData == 'Admin') {
            return true;
        }
        this.router.navigate(['auth/login'], { queryParams: { returnUrl: state.url } });
        return false;
    };
    AdminGuard.ngInjectableDef = i0.defineInjectable({ factory: function AdminGuard_Factory() { return new AdminGuard(i0.inject(i1.Router)); }, token: AdminGuard, providedIn: "root" });
    return AdminGuard;
}());
export { AdminGuard };
